import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Grid, Header, Segment, Button, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <>
      <Helmet>
        <title>Miakara Soap Recipes - Home</title>
      </Helmet>

      <Container>
        <Segment vertical>
          <Grid>
            <Grid.Row>
              <Grid.Column width={16} textAlign="center">
                <Header as="h1" size="huge">
                  Welcome to Miakara Soap Recipes 
                </Header>
                <Header as="h2" size="large" color="grey">
                  Your Ultimate Soap Making Companion
                </Header>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row columns={2} divided>
              <Grid.Column>
                <Segment padded="very" textAlign="center">
                  <Icon name="calculator" size="huge" />
                  <Header as="h3">Soap Calculator</Header>
                  <p>Calculate your soap recipes with precision</p>
                  <Button as={Link} to="/calculator" primary>
                    Try Calculator
                  </Button>
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment padded="very" textAlign="center">
                  <Icon name="book" size="huge" />
                  <Header as="h3">Recipe Database</Header>
                  <p>Browse and share soap recipes</p>
                  <Button as={Link} to="/recipes" primary>
                    View Recipes
                  </Button>
                </Segment>
              </Grid.Column>

              
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={16} textAlign="center">
                <Header as="h2">Featured Resources</Header>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row columns={1} divided>
              <Grid.Column>
                <Segment padded="very">
                  <Header as="h3">
                    <Icon name="flask" />
                    Oil Database
                  </Header>
                  <p>Explore our comprehensive database of oils and their properties</p>
                  <Button as={Link} to="/oils" secondary>
                    Browse Oils
                  </Button>
                </Segment>
              </Grid.Column>

              
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    </>
  );
}

export default Home; 